module.exports = {
    content_cloud_url: 'https://content.thismomentone.com',
    env_host: 'thismomentone.com',
    env_name: 'prod',
    fb_app_id: '676752229025534',
    file_upload_url: 'https://ccmt-upload-prod.s3-us-west-2.amazonaws.com',
    file_processor_url: 'https://bqpafq0bv9.execute-api.us-west-2.amazonaws.com/prod/invoke-sfn-process',
    media_upload_url: 'https://media-upload.thismomentone.com',
    media_processor_url: 'https://media-process.thismomentone.com/invoke-sfn-process',
    language: 'en',
    recaptcha_key: '6LfkSz4tAAAAAO1SKOojYiNQYj3xEgvDYEpZDcyG',
    recaptcha_key_v3: '',
    segment_api_key: 'sZBRhWJGJaT7bzVDKg5NXLCgf8kaY9Yn'
}



// WEBPACK FOOTER //
// ./src/env.js